import { render, staticRenderFns } from "./president.vue?vue&type=template&id=56263621&scoped=true&"
import script from "./president.vue?vue&type=script&lang=js&"
export * from "./president.vue?vue&type=script&lang=js&"
import style0 from "./president.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./president.vue?vue&type=style&index=1&id=56263621&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56263621",
  null
  
)

export default component.exports